module.exports = __webpack_public_path__ + "img/Skirt-Back-B5-Da-Ga-Ha-Ia-Gb.84abf15b.png";